import React from 'react';
import ImportantMessages from './ImportantMessages';
import ImportantMessageFallback from './ImportantMessageFallback.jsx';
import ContentoQuery, { ContentoError, ContentoData } from '../Contento/ContentoQuery';
import ImportantMessagesQuery from './ImportantMessages.graphql';
import { useRouter } from 'next/router';

const ImportantMessagesContainer = () => {
    const router = useRouter();

    return (
        <ContentoQuery
            key={router?.asPath}
            fetchPolicy="cache-and-network"
            query={ImportantMessagesQuery}
            queryTimeout={3000}
            isLoadingScreenEnabled={false}
        >
            <ContentoData>
                {(data) => {
                    return <ImportantMessages messages={data.importantMessages} />;
                }}
            </ContentoData>

            <ContentoError>
                <ImportantMessageFallback />
            </ContentoError>
        </ContentoQuery>
    );
};

export default ImportantMessagesContainer;
